<template>
  <div id="product-list-container-id">
<!--    PC端内容-->
    <div class="productList">
      <div class="banner" id="banner" @mouseenter="bannerSwiperMouseenter" @mouseleave="bannerSwiperMouseleave">
        <swiper :options="bannerSwiper" ref="bannerSwiperRef">
          <!-- slides -->
          <swiper-slide v-for="(item,index) in filterBillboard(this.billboards, $i18n.locale)" data-index="index"
                        :key="index">
            <div v-if="item.URL"><a style="cursor: pointer" @click="onClickBillboard(item.URL, item.MIMEType)"><img
              class='swiImg' :src='item.Image'/></a></div>
            <div v-else><img class='swiImg' :src='item.Image'/></div>
          </swiper-slide>
        </swiper>
        <div class="banner-button-prev">
          <font-awesome-icon icon="chevron-left" :style="{ color: 'black', fontSize: '20px', marginRight: '10px' }"/>
        </div>
        <div class="banner-button-next">
          <font-awesome-icon icon="chevron-right" :style="{ color: 'black', fontSize: '20px', marginLeft: '10px'  }"/>
        </div>
      </div>

      <!-- <div class="icon-sub-header">
        <div class="icon-box">
          <div class="icon-square">
            <div class="icon-cont">
              <img src="../assets/img/freeDelivery.svg" style="height: 56px; width: 56px"/> -->
<!--              <font-awesome-icon icon="truck" :style="{ color: 'black', fontSize: '50px',  }"/>-->
            <!-- </div>
            <p class="icon-header">{{ $t('free_delivery_over') }}</p>
          </div>
          <div class="icon-square">
            <div class="icon-cont-ticket">
              <img src="../assets/img/homeTicket.svg" style="height: 56px; width: 56px"/> -->
<!--              <font-awesome-icon icon="ticket-alt" :style="{ color: 'black', fontSize: '50px'}"/>-->
            <!-- </div>
            <p class="icon-header">{{ $t('the_first_order') }}</p>
          </div>
          <div class="icon-square">
            <div class="icon-cont"> -->
<!--              <font-awesome-icon icon="check-square" :style="{ color: 'black', fontSize: '50px'}"/>-->
              <!-- <img src="../assets/img/homeGuarantee.svg" style="height: 56px; width: 56px"/>
            </div>
            <p class="icon-header">{{ $t('quality_guarantee') }}</p>
          </div>
        </div>
      </div> -->

      <div class="category-buttons" id="category-buttons">
        <ul>
          <li v-for="(item, index) in allGroups" :key="index">
            <div class="group-button-container">
              <div class="image-placeholder" @click="selectNewGroup(item)">
                <img class="button-image" :src="item.Image" alt="">
              </div>
              <p class="group-button-name">{{ curIsEnglish ? item.Name : item.Description }}</p>
            </div>
          </li>
        </ul>
      </div>

      <!-- <div class="filter-bar-container" ref="filterBarRef"> -->
        <!-- <div class="filter-left">
          <p>{{ $t('filter') }}</p> -->
<!--          <i class="fa fa-refresh" aria-hidden="true" @click="refreshFilter()" :style="{cursor: 'pointer' }"></i>-->
          <!-- <img src="../assets/img/icons-general-update.svg" @click="refreshFilter()" :style="{cursor: 'pointer' }">
        </div> -->
        <!-- <div class="filter-right">
          <div class="switch-view-filter">
            <img src="../assets/img/switch1_on.svg" v-if="currentViewIsGallery" class="switch1" alt="">
            <img src="../assets/img/switch1_off.svg" v-if="!currentViewIsGallery" class="switch1" @click="switchView('gallery')" alt="">
            <img src="../assets/img/switch2_on.svg" v-if="!currentViewIsGallery" class="switch2" alt="">
            <img src="../assets/img/switch2_off.svg" v-if="currentViewIsGallery" class="switch2" @click="switchView('list')" alt="">
          </div>
        </div>
      </div> -->

      <div class="product-listing-container">
        <!-- <breadcrumb v-bind:path2="path2"></breadcrumb> -->
        <!-- <breadcrumb ></breadcrumb> -->
        <!-- <div class="breadcrumb-container">
          <div class="breadcrumb-fill"></div>
            <el-breadcrumb class="breadcrumb-products" separator=">">
              <el-breadcrumb-item><a class="bread-text">{{ $t('products') }}</a></el-breadcrumb-item>
              <el-breadcrumb-item v-if="$i18n.locale == 'en'"><a class="bread-text">{{this.activeGroupEn}}</a></el-breadcrumb-item>
              <el-breadcrumb-item v-if="$i18n.locale == 'ch'"><a class="bread-text">{{this.activeGroupCh}}</a></el-breadcrumb-item>
              <el-breadcrumb-item v-if="this.activeCategoryEn && $i18n.locale == 'en'"><a class="bread-text">{{this.activeCategoryEn}}</a></el-breadcrumb-item>
              <el-breadcrumb-item v-if="this.activeCategoryCh && $i18n.locale == 'ch'"><a class="bread-text">{{this.activeCategoryCh}}</a></el-breadcrumb-item>
            </el-breadcrumb>
        </div> -->
        <div class="product-list-container">
          <!-- <div class="category-filter">
            <div :style="{marginBottom: '30px'}">
              <div class="category-header-back">
                <font-awesome-icon icon="arrow-left" @click="goToHome()"
                                   :style="{ color: '#818181', fontSize: '24px', cursor: 'pointer' }"/>
                <p class="category-title" :style="{cursor: 'pointer' }" @click="goToHome()">{{ $t('back') }}</p>
              </div>
            </div>
            <div :style="{marginBottom: '30px'}">
              <div class="category-header">
                <font-awesome-icon
                  icon="chevron-up"
                  :style="{ color: '#818181', fontSize: '24px', cursor: 'pointer'  }"
                  @click="toggleCustomCategories"
                  :class="customCategoriesOpen ? 'rotate' : 'rotate-back'"/>
                <p class="category-title"
                   :style="{cursor: 'pointer'}"
                   @click="toggleCustomCategories">
                  {{ $t('hotlists') }}
                </p>
              </div>
              <el-checkbox-group
                v-for="(item,index) in this.customCategories"
                :key="index"
                v-model="selectedCustomCategoryLocal"
                v-show="customCategoriesOpen"
                @change="selectNewCustomCategory(item,index, true)">
                <el-checkbox
                  v-if="formatCustomCategoriesCheckbox(item)"
                  :label="item.Name">
                  {{ formatCustomCategoriesCheckbox(item) }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="pc-categories-filter-container" :style="{marginBottom: '30px'}">
              <div class="category-header">
                <font-awesome-icon
                  icon="chevron-up"
                  :style="{ color: '#818181', fontSize: '24px', cursor: 'pointer'  }"
                  :class="groupsOpen ? 'rotate' : 'rotate-back'"/>
                <p class="category-title"
                   :style="{cursor: 'pointer'}"
                   @click="toggleGroups">
                  {{ $t('categories') }}
                </p>
              </div>
              <el-checkbox-group
                v-for="(item,index) in allGroups"
                :key="index"
                v-model="selectedGroupLocal"
                @change="selectNewGroup(item)">
                <el-checkbox :class="{'pc-category-subclass-buttons-container': selectedGroupLocal.includes(item.Name)}"
                             :label="item.Name">
                  {{ curIsEnglish ? item.Name : item.Description }}
                  <div class="pc-category-subclass-buttons" @click.stop> -->
<!--                    v-model="selectedGroupLocal"-->
<!--                    @change="selectNewGroup(item)"-->
                    <!-- <el-checkbox-group v-model="allGroups_Categories_ids" @change="allGroupsCategoriesSelect({}, true)">
                      <el-checkbox
                        v-for="(ite,index) in allGroups_Categories"
                        :label="ite.ProductCategory_id"
                        :class="{active:allGroups_Categories_ids.includes(ite.ProductCategory_id)}"
                        :key="'allGroups_Categories_'+index">
                        {{ curIsEnglish ? ite.Name : ite.Description }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                </el-checkbox>
              </el-checkbox-group>
            </div>

            <div class="brand-filter">
              <div class="brand-header">
                <div class="brand-start">
                  <font-awesome-icon
                    icon="chevron-up"
                    :style="{ color: '#818181', fontSize: '24px', cursor: 'pointer'  }"
                    @click="toggleBrand"
                    :class="brandOpen ? 'rotate' : 'rotate-back'"/>
                  <p class="category-title"
                     :style="{cursor: 'pointer'}"
                     @click="toggleBrand">
                    {{ $t('brand') }}
                  </p>
                </div>
                <div class="brand-close">
                  <font-awesome-icon
                    icon="times"
                    :style="{ color: '#818181', fontSize: '24px', cursor: 'pointer'  }"
                    @click="cleanBrand"/>
                </div>
              </div>
            </div>
            <el-checkbox-group
              v-for="(item,index) in this.brandFilterOptions"
              :key="index"
              v-model="brandFilter"
              v-show="brandOpen"
              @change="adjustPriceSort">
              <el-checkbox :label="item">
                {{ item }}
              </el-checkbox>
            </el-checkbox-group>

            <div class="price-filter">
              <div class="price-header">
                <div class="price-start">
                  <font-awesome-icon
                    icon="chevron-up"
                    :style="{ color: '#818181', fontSize: '24px', cursor: 'pointer'  }"
                    @click="togglePrice"
                    :class="priceOpen ? 'rotate' : 'rotate-back'"/>
                  <p class="category-title"
                     :style="{cursor: 'pointer'}"
                     @click="togglePrice">
                    {{ $t('price') }}&nbsp;&nbsp;{{ this.priceFilterDisplay }}</p>
                </div>
                <div class="price-close">
                  <font-awesome-icon
                    icon="times"
                    :style="{ color: '#818181', fontSize: '24px', cursor: 'pointer'  }"
                    @click="cleanPrice"/>
                </div>
              </div>
              <el-slider
                v-show="priceOpen"
                :min="1"
                :max="51"
                class="slider-settings"
                :tooltip-class="'testslider'"
                @change="adjustPriceSort"
                :format-tooltip="formatToolTip"
                v-model="priceFilter">
              </el-slider>
            </div>
          </div> -->
          <div></div>
          <div class="products">
            <div class="products_div" id="products_div">
              <div class="breadcrumb-container">
                <div class="breadcrumb-fill"></div>
                <img class="bread-img"
                    :style="{cursor: 'pointer'}"
                    src="../assets/img/breadcrumb-home.png"
                    @click="$router.push('/home')">
                <el-breadcrumb class="breadcrumb-products" separator=">">
                  <el-breadcrumb-item>
                    <a class="bread-text">{{ $t('products') }}</a>
                  </el-breadcrumb-item>
                  <el-breadcrumb-item
                    v-if="activeGroupEn && curIsEnglish">
                    <a class="bread-text">{{ activeGroupEn }}</a>
                  </el-breadcrumb-item>
                  <el-breadcrumb-item
                    v-if="activeGroupCh && curIsChinese">
                    <a class="bread-text">{{ activeGroupCh }}</a>
                  </el-breadcrumb-item>
                  <el-breadcrumb-item
                    v-if="activeCategoryEn && curIsEnglish">
                    <a class="bread-text">{{ activeCategoryEn }}</a>
                  </el-breadcrumb-item>
                  <el-breadcrumb-item
                    v-if="activeCategoryCh && curIsChinese">
                    <a class="bread-text">{{ activeCategoryCh }}</a>
                  </el-breadcrumb-item>
                </el-breadcrumb>
              </div>
              <div class="is-stockLevel" v-if="loggedIn">
                <el-checkbox v-model="priceChecked" @change="isPrice">{{$t('price')}}</el-checkbox>
              </div>
              <div class="is-stockLevel" v-if="loggedIn">
                <el-checkbox v-model="stockLevelChecked" @change="isSockLevel">{{$t('in_stock')}}</el-checkbox>
              </div>
              <div class="sort-by-filter">
                <span>{{ $t('sortBy') }} :</span>
                <afmSelect
                  v-model="sortByFilter"
                  @change="adjustPriceSort"
                  :optionList="sortByOptions"
                  :hoverIsShow="true"
                  :placeholder="$t('pleaseSelectSortingMethod')">
                </afmSelect>
              </div>
            </div>
            <ul v-if="!isLoading">
              <li
                v-for="(item, index) in showList"
                v-bind:key="index"
                :class="{'list-view': !currentViewIsGallery}"
                v-if="!item.IsStopSale && (showMore || index<9)">
                <!-- {{item}} -->
                <productCard
                  ref="productCardRef"
                  @imgLoad="imgLoad"
                  @imgAbort="imgAbort"
                  v-show="currentViewIsGallery"
                  v-bind:img="item.ThumbnailLarge"
                  v-bind:link="item.link"
                  v-bind:brand="item.Brand"
                  v-bind:rating="item.Rating"
                  v-bind:name="item.Name"
                  v-bind:description="item.Description"
                  v-bind:isPromotion="item.IsPromotion"
                  v-bind:price="item.Price"
                  v-bind:item="item"
                  v-bind:inCart="inCart"
                  v-bind:quantity="item.Quantity"
                  v-bind:key="index"
                  v-bind:refNum="item.RefNum"
                  v-bind:productNum="item.ProductNum"
                  v-bind:barcode="item.barcode || item.Barcode"
                  v-bind:packageSize="item.PackageSize"
                ></productCard>
<!--                因为样的层级问题比较复杂，所以一个一个判断吧-->
                <div v-show="!currentViewIsGallery" class="list-container-1">
                  <buy-one-get-one
                    v-if="item.BuyAGetB_promotion"
                    v-bind:fromQty="item.BuyAGetB_FromQty"
                    v-bind:relatedQty="item.BuyAGetB_RelatedQty"
                  ></buy-one-get-one>
                  <!-- <img :src="item.Thumbnail" alt="" @click="goToProductDetail(item)"> -->
                  <img :src="item.Thumbnail" alt="">
                </div>
                <div v-show="!currentViewIsGallery" class="list-container-2">
                  <p class="list-brand" @click="selectNewSearch(item.Brand, 'Brand')">{{ item.Brand }}</p>
                  <p class="list-name">{{ curIsEnglish ? item.Name : item.Description }}</p>
                  <div class="list-star-container">
                    <img v-for="(item2,index) in getStarIndex(item.Rating)"
                         :data-index="index"
                         :key="index"
                         class="list-star-img"
                         :src="item2" alt="">
                    <p class="list-star-text">{{ item.Rating }}</p>
                  </div>
                </div>
                <div v-show="!currentViewIsGallery" class="list-container-3">
                  <p class="list-price-original" v-if="item.OriginalPrice">
                    ${{ item.OriginalPrice ? item.OriginalPrice.toFixed(2) : '' }}</p>
                  <p class="list-price" :class="{'list-price-promo':item.OriginalPrice||item.BuyAGetB_promotion}">${{ item.Price ? item.Price.toFixed(2) : '' }}</p>
                </div>
                <div v-show="!currentViewIsGallery" class="list-container-4">
                  <button v-if="isOutOfStock(item)" class="ajax_addto_cart_btn">{{ $t('outOfStock') }}</button>
                  <button
                    v-else
                    class="ajax_addto_cart_btn"
                    @click="throttleAddToCart(item, $event)"
                  >
                    {{ $t('addToCart') }}
                  </button>
                </div>
              </li>
            </ul>
            <div v-else class="loadingWindow">
              <img src="../assets/img/loading.gif" alt="">
            </div>
            <div class="show-more-container" v-if="isShowShowMoreContent">
              <button id="product-show-more-button" class="show-more-button" @click="clickShowMore()">{{ $t('showMore') }}</button>
            </div>
          </div>
        </div>
      </div>

      <pcRecommended class="recommended-outer-container" id="pcRecommended" :isShowButton="false" :inCart="inCart"></pcRecommended>

      <!-- <div class="recommended-more-container"> -->
        <!--        <button class="recommended-more-button" @click="showMoreRecommend()">{{ $t('showMore') }}</button>-->
      <!-- </div> -->

      <!-- <div class="home-footer">
        <div class="icon-col" style="borderRight: 1px solid rgba(0, 0, 0, 0.25)">
          <div class="homeFooter-img">
            <img src="../assets/img/headset.svg" style="height: 50px; width: 50px"/>
          </div>
          <div class="homeFooter-text">
            <h2>{{ $t('customer_service') }}</h2>
            <p>{{ $t('call_chat_visit') }}</p>
          </div>
        </div>
        <div class="icon-col">
          <div class="homeFooter-img">
            <img src="../assets/img/truckHome.svg" style="height: 50px; width: 50px"/>
          </div>
          <div class="homeFooter-text">
            <h2>{{ $t('free_shipping') }}</h2>
            <p>{{ $t('get_shopafm_free') }}</p>
          </div>
        </div>
        <div class="icon-col" style="borderLeft: 1px solid rgba(0, 0, 0, 0.25)">
          <div class="homeFooter-img">
            <img src="../assets/img/onlinePayment.svg" style="height: 50px; width: 50px"/>
          </div>
          <div class="homeFooter-text">
            <h2>{{ $t('online_payment') }}</h2>
            <p>{{ $t('we_accept_all') }}</p>
          </div>
        </div>
      </div> -->
    </div>
<!--    手机端内容-->
    <div class="MbproductList botPage">
      <mbHeader :title="$t('categories')" :left="true" @searchProduct="searchProduct" @selectNewGroup="selectNewGroup">
        <div class="right" @click="viewSwitch = !viewSwitch">
          <img src="../assets/img/menus.png" alt="" v-if="viewSwitch">
          <img src="../assets/img/tabbar2.png" alt="" v-else>
        </div>
      </mbHeader>
      <div class="banner">
        <swiper :options="bannerSwiper">
          <swiper-slide v-for="(item,index) in filterBillboard(this.billboards, $i18n.locale)" data-index="index"
                        :key="index">
            <div v-if="item.URL"><a style="cursor: pointer" @click="onClickBillboard(item.URL, item.MIMEType)"><img
              class='swiImg' :src='item.Image'/></a></div>
            <div v-else><img class='swiImg' :src='item.Image'/></div>
          </swiper-slide>
        </swiper>
        <div class="banner-button-prev">
          <font-awesome-icon icon="chevron-left" :style="{ color: 'black', fontSize: '20px', marginRight: '10px' }"/>
        </div>
        <div class="banner-button-next">
          <font-awesome-icon icon="chevron-right" :style="{ color: 'black', fontSize: '20px', marginLeft: '10px'  }"/>
        </div>
      </div>

      <div class="searchFor">
        <div class="searchBox">
          <input type="text" :placeholder="$t('search_for')" v-model="searchTerm" @keypress.enter="searchProduct">
          <div class="glass">
            <font-awesome-icon icon="search" :style="{ color: 'white', fontSize: '12px' }" @click="searchProduct"/>
          </div>
        </div>
        <div class="showClass" @click="showppoducts=!showppoducts">
          <img src="../assets/img/category2.png" alt="" v-if="!showppoducts">
          <img src="../assets/img/category1.png" alt="" v-else>
        </div>
      </div>

      <div class="hotlists" v-show="isShowHotLists">
        <span
          :ref="'hot-'+index"
          :class="{active:selectedCustomCategoryLocal.includes(item.Name)}"
          @click="selectNewCustomCategory(item,index, true)"
          v-for="(item,index) in this.customCategories"
          v-if="formatCustomCategoriesCheckbox(item)"
          :key="'hot-'+index">
          {{ formatCustomCategoriesCheckbox(item) }}
        </span>
      </div>

      <div class="category-buttons" :class="{'hidden': !isShowCategoryButtons}" v-show="isShowCategoryButtons">
        <ul class="allGroups">
          <li
            :ref="'allGroups'+index"
            v-for="(item, index) in allGroups"
            :key="index"
            :class="{groupsActive:selectedGroupLocal.indexOf(item.Name) > -1}">
            <div class="group-button-container">
              <div class="image-placeholder" @click="selectNewGroup(item)">
                <img class="button-image" :src="item.Image" alt="">
              </div>
              <p class="group-button-name">{{ curIsEnglish ? item.Name : item.Description }}</p>
            </div>
          </li>
        </ul>
      </div>

      <div
        class="category-subclass-buttons"
        id="fixedRef"
        :class="{'fixed_container': isFixed}"
        v-if="isShowCategorySubclassButtons">
        <ul class="allGroups_Categories">
          <li
            v-for="item in allGroups_Categories"
            @click="allGroupsCategoriesSelect(item)"
            :class="{active:allGroups_Categories_ids.includes(item.ProductCategory_id)}">
            <p class="group-button-name">{{ curIsEnglish ? item.Name : item.Description }}</p>
          </li>
        </ul>
      </div>

      <div
        class="products"
        :class="{vertical:viewSwitch}">
        <ul v-if="!isLoading">
          <li
            v-for="(item, index) in showList"
            v-bind:key="index"
            v-if="!item.IsStopSale && (showMore || index<9)">
            <buy-one-get-one
              v-if="item.BuyAGetB_promotion"
              v-bind:fromQty="item.BuyAGetB_FromQty"
              v-bind:relatedQty="item.BuyAGetB_RelatedQty"
            ></buy-one-get-one>
            <div class="left">
              <!-- <img
                v-lazy="item.Thumbnail"
                :key="item.Thumbnail"
                :src="item.Thumbnail"
                alt=""
                @click="goToProductDetail(item)"> -->
              <img
                v-lazy="item.Thumbnail"
                :key="item.Thumbnail"
                :src="item.Thumbnail"
                alt=""
                @click="clickZoom(item.Thumbnail)"
              >
            </div>
            <!-- <div class="min" @click="goToProductDetail(item)"> -->
            <div class="min">
              <p class="refNum-name">{{item.RefNum}}</p>
              <p class="list-brand">{{item.Name}}{{' , '+item.Description}}</p>
              <!-- <p class="list-name" @click.stop="selectNewSearch(item.Brand, 'Brand')">{{ item.Brand }}</p> -->
              <div>
                {{item.PackageSize}}
              </div>
              <div class="price" v-if="loggedIn">
                <!-- <afmStar :isOneStar="true" :rating="item.Rating"></afmStar> -->
                <p class="list-price-original" v-if="item.OriginalPrice">{{item.OriginalPrice.toFixed(2)}}</p>
                <p class="list-price" :class="{'list-price-promo':item.OriginalPrice||item.BuyAGetB_promotion}">${{ item.Price ? item.Price.toFixed(2) : '' }}</p>
              </div>
              <div class="price" v-else>
                <p class="list-price-original" v-if="item.OriginalPrice">------</p>
                <p class="list-price" :class="{'list-price-promo':item.OriginalPrice||item.BuyAGetB_promotion}">------</p>
              </div>
              <div class="text_center">
                <barcode v-if="item.barcode" :value="item.barcode" :options="barcode_option"></barcode>
              </div>
            </div>
            <!-- <div class="right outOfStock" v-if="isOutOfStock(item)">{{ $t('outOfStock') }}</div>
            <div class="right" v-else @click="throttleAddToCart(item, $event)">
              <img src="../assets/img/Category_add.png" alt="">
            </div> -->
          </li>
        </ul>
        <div v-else class="loadings">
          <img src="../assets/img/loading.gif" alt="">
        </div>
        <div class="show-more-container" v-if="isShowShowMoreContent">
          <button id="product-show-more-button" class="show-more-button" @click="clickShowMore()">{{ $t('showMore') }}</button>
        </div>
        <!--        <div class="nodeData" style="display: none" v-if="list.length<=0 && !isLoading">{{ $t('noMoreProducts') }}</div>-->
      </div>

      <recommended v-if="!isLoading"></recommended>

<!--      选择分类弹框-->
      <div class="popupbt allProducts" :class="{showpop:showppoducts}">
        <div class="model-pop" @click="showppoducts = !showppoducts" @touchmove.prevent></div>
        <div class="pop-content">
          <div class="close" @click="showppoducts = !showppoducts">
            <img src="../assets/img/close.png" alt="">
          </div>
          <div class="category-filter">
            <div>
              <div class="filter_header">
                <p class="category-title" @click="toggleCustomCategories">{{ $t('hotlists') }}</p>
                <font-awesome-icon
                  icon="chevron-up"
                  @click="toggleCustomCategories"
                  :class="customCategoriesOpen ? 'rotate' : 'rotate-back'"/>
                <i class="fa fa-refresh"
                   aria-hidden="true"
                   @click="refreshFilter()"
                   :style="{cursor: 'pointer' }"></i>
              </div>
              <el-checkbox-group
                v-for="(item,index) in this.customCategories"
                :key="index"
                v-model="selectedCustomCategoryLocal"
                v-show="customCategoriesOpen"
                @change="selectNewCustomCategory(item,index, true),showppoducts = false">
                <el-checkbox
                  v-if="formatCustomCategoriesCheckbox(item)"
                  :label="item.Name">
                  {{ formatCustomCategoriesCheckbox(item) }}
                </el-checkbox>
              </el-checkbox-group>
            </div>

            <div>
              <div class="filter_header">
                <p class="category-title" @click="toggleGroups">{{ $t('categories') }}</p>
                <font-awesome-icon
                  icon="chevron-up"
                  @click="toggleGroups"
                  :class="groupsOpen ? 'rotate' : 'rotate-back'"/>
              </div>
              <el-checkbox-group
                v-for="(item,index) in allGroups"
                :key="index"
                v-model="selectedGroupLocal"
                v-show="groupsOpen"
                @change="selectNewGroup(item),showppoducts = false">
                <el-checkbox :label="item.Name">{{ curIsEnglish ? item.Name : item.Description }}</el-checkbox>
              </el-checkbox-group>
            </div>


            <div>
              <div class="filter_header">
                <p class="category-title"
                   :style="{cursor: 'pointer'}"
                   @click="toggleBrand">
                  {{ $t('brand') }}
                </p>
                <font-awesome-icon
                  icon="chevron-up"
                  @click="toggleBrand"
                  :class="brandOpen ? 'rotate' : 'rotate-back'"/>
              </div>
              <el-checkbox-group
                v-for="(item,index) in this.brandFilterOptions"
                :key="index"
                v-model="brandFilter"
                v-show="brandOpen"
                @change="adjustPriceSort(),showppoducts = false">
                <el-checkbox :label="item">{{ item }}</el-checkbox>
              </el-checkbox-group>
            </div>

            <div>
              <div class="filter_header">
                <p class="category-title"
                   @click="togglePrice">
                  {{ $t('price') }}&nbsp;&nbsp;{{ this.priceFilterDisplay }}
                </p>
                <font-awesome-icon
                  icon="chevron-up"
                  @click="togglePrice"
                  :class="priceOpen ? 'rotate' : 'rotate-back'"/>
              </div>
              <el-slider
                v-show="priceOpen"
                :min="1"
                :max="51"
                class="slider-settings"
                :tooltip-class="'testslider'"
                @change="adjustPriceSort"
                :format-tooltip="formatToolTip"
                v-model="priceFilter">
              </el-slider>
            </div>
          </div>
        </div>
      </div>
      <div class="images-modal-mask" v-if="imagesVisible" @click.self="closeImages">
        <div class="images">
          <img :src="images" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';

// import breadcrumb from "@/components/breadcrumb";
import Utils from "../assets/js/util";
import busUtil from "../assets/js/util";
import productCard from "./productCard";
import mbHeader from "../components/mobile/mbHeader";
import buyOneGetOne from "../components/buy-one-get-one/buy-one-get-one";
import star0 from '../assets/img/star0.jpg'
import star1 from '../assets/img/star1.jpg'
import star2 from '../assets/img/star2.jpg'
import {isUserAuthenticated} from "../store/modules/cart";
import recommended from "./recommended";
import afmStar from "../components/afm-star/afm-star";
import afmSelect from "../components/afm-select/afm-select";
import pcRecommended from "../components/pc-recommended/pc-recommended";
import {locales, outOfStockSorts, toProductDetail, uni} from "../mixin";
import barcode from "@xkeshi/vue-barcode";

const SELECT_NEW_GROUP = 'selectNewGroup'
const SELECT_NEW_CUSTOM_CATEGORY  = 'selectNewCustomCategory'
const ALL_GROUPS_CATEGORIES_SELECT  = 'allGroupsCategoriesSelect'
const GALLERY  = 'gallery'
const SEARCH_NAME  = 'searchName'
const defaultIsPage = true

export default {
  name: "productList",
  mixins: [outOfStockSorts, locales, toProductDetail, uni],
  components: {
    // breadcrumb,
    productCard,
    mbHeader,
    recommended,
    afmStar,
    afmSelect,
    pcRecommended,
    'buy-one-get-one': buyOneGetOne,
    barcode
  },
  data() {
    return {
      showppoducts: false,
      viewSwitch: false,
      isLoading: false,
      // path2: this.currentGroup,
      bannerSwiper: {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        simulateTouch: false,
        navigation: {
          nextEl: '.banner-button-next',
          prevEl: '.banner-button-prev',
        },
      },
      chgroup: '',
      sonNavList: [],
      option: "",//下拉框选项值
      sortByFilter: '1',
      sortByOptions: [{
        value: '1',
        label_en: 'Default',
        label_ch: '默認'
      }, {
        value: '2',
        label_en: 'Name',
        label_ch: '品名'
      }, {
        value: '3',
        label_en: 'Price',
        label_ch: '價格'
      },],
      list: [],
      listReg: [],
      listOut: [],
      catReg: [],
      catOut: [],
      inCart: null,
      activeGroupEn: '',
      activeGroupCh: '',
      activeCategoryEn: '',
      activeCategoryCh: '',
      filter: '',
      groupsOpen: true,
      customCategoriesOpen: true,
      brandOpen: true,
      priceOpen: true,
      selectedGroupLocal: [],
      selectedCustomCategoryLocal: [],
      priceFilter: 51,
      priceFilterDisplay: '',
      // currentGroupId: '',
      brandFilter: [],
      brandFilterOptions: [],
      showMore: true,
      searchType: '',
      searchBrand: '',
      currentView: GALLERY,// 当前展示的商品的样式
      currentGroupCategories: [],

      searchTerm: "",
      allGroups_Categories: [],
      allGroups_Categories_id: null,
      reqProductsWithCustomCategoryData: [],
      allGroups_Categories_ids: [],
      isFixed: false,
      curSelectNewCategoryItem: null,
      pageInfo: {
        pageSize: 100,
        pageNum: 1,
        total: 0
      },
      // 是否分页
      isPage: defaultIsPage,
      barcode_option: {
        displayValue: true, //是否默认显示条形码数据
        background: 'rgba(0,0,0,0)', //条形码背景颜色
        width: '1.8rem',
        height: '24px',
        fontSize: '12px',
        lineColor: '#000',
      },
      //是否显示有库存
      stockLevelChecked: false,
      //是否显示价格
      priceChecked: true,
      //备份的产品数据
      list2: [],
      //商品图片的弹窗
      imagesVisible: false,
      images: ''
    }
  },
  methods: {
    ...mapActions('products', ['fetchCategories', 'fetchProductsWithGroupId', 'fetchProductsWithGroupAll', 'fetchProductsWithCustomCategoryId', 'fetchBrands','changeShowPrice']),
    ...mapMutations('products', ['updateSelectedGroupGlobal', 'updateSelectedCustomCategoryGlobal', 'updateSelectedCategoryGlobal', 'updateSelectedSearchGlobal']),
    ...mapActions('cart', ['addProductToCart']),
    ...mapMutations('checkout', ['setPricesForCheckout', 'saveTotalPrice', 'saveGrandTotal', 'clearPromoCode', 'clearCard']),
    ...mapActions('search', ['fetchProducts']),
    ...mapMutations('navbar', ['toggleZipcodeModalVisibility', 'toggleWarehouseSelectionModalVisibility']),
    ...mapActions(['changeNavGoId','changeShowProductsType1','changeShowProductsType2','changeShowProductsType3','changeShowList']),
    allGroupsCategoriesSelect(item, isMultiple){
      let ids = item.ProductCategory_id
      if (ids && !isMultiple) {
        const idx = this.allGroups_Categories_ids.indexOf(ids)
        if (idx > -1) {
          this.allGroups_Categories_ids.splice(idx, 1)
        } else {
          this.allGroups_Categories_ids.push(ids)
        }
        this.setLocalAllGroupsCategoriesIds();
        isMultiple = true
      }
      this.allGroups_Categories_id = ids
      if (isMultiple) {
        ids = this.allGroups_Categories_ids.join(',')
        this.allGroups_Categories_id = this.allGroups_Categories_ids[0]
      }
      if (!ids) {// 没有选择二级分类，查询父级数据
        const groupSelect0 = this.selectedGroupLocal[0]
        if (!groupSelect0) {
          return;
        }
        const resItem = this.allGroups.find(item => item.Name === groupSelect0)
        resItem && this.selectNewGroup(resItem)
        return
      }
      // 选择了二级分类
      this.setLocalAllGroupsCategoriesIds();
      const selectGroupsCategories = this.allGroups_Categories.filter(item => this.allGroups_Categories_ids.includes(item.ProductCategory_id))
      if (selectGroupsCategories.length) {
        let activeCategoryEnList = []
        let activeCategoryChList = []
        selectGroupsCategories.forEach(item => {
          const {Name, Description} = item;
          activeCategoryEnList.push(Name);
          activeCategoryChList.push(Description)
        })
        this.activeCategoryEn = activeCategoryEnList.join(',');
        this.activeCategoryCh = activeCategoryChList.join('，');
      }
      this.fetchSelectedCategories(ids)
    },
    initializeSelection(isActivated = false, isAllGroupsCategories = false) {
      this.isLoading = true;
      const param1 = JSON.parse(localStorage.getItem(SELECT_NEW_GROUP))
      const param3 = JSON.parse(localStorage.getItem(ALL_GROUPS_CATEGORIES_SELECT))
      const param4 = localStorage.getItem(SEARCH_NAME) // 搜索

      if (param4) {
        return this.updateSelectedSearchGlobal([param4]);
      }

      if (param1) {
        let data = this.allGroups[0]
        if (isActivated && !data) {
          return setTimeout(() => {
            this.initializeSelection(false, isAllGroupsCategories)
          }, 2000)
        }
        data = this.allGroups.find(item => item.Name === param1.Name) || data
        return this.selectNewGroup(data).then(() => {
          if (!isAllGroupsCategories || !Array.isArray(param3) || !param3.length || !data) {
            return
          }
          setTimeout(() => {// 需要等selectNewGroup
            this.allGroups_Categories = data.Categories;
            this.allGroups_Categories_ids = param3;
            this.setLocalAllGroupsCategoriesIds();
            this.allGroupsCategoriesSelect(data, true)
          }, 2000)
        })
      }
      const param2 = JSON.parse(localStorage.getItem(SELECT_NEW_CUSTOM_CATEGORY))
      this.fetchProductsWithCustomCategoryId({id:'',company_id:this.companyId,warehouse_id:this.warehouseId})
        .then(res => {
          this.isLoading = false;
          const resData = res.data
          if (!resData && !resData.length) {
            return
          }
          let data = resData[0]
          if (param2) {
            data = resData.find(item => item.Name === param2.Name) || data
          }
          const {Name, Description, ProductCategory2_id} = data
          this.selectedCustomCategoryLocal = [Name];
          this.navCustomCategory({
            Name,
            Description,
            ProductCategory2_id
          });
          this.selectNewCustomCategory(data)
        })
        .catch(err => {
          this.isLoading = false;
          console.log('err', err);
        });
    },
    filterBillboard(billboard, language) {
      const filterBillboard = billboard.filter(image => {
        return image.Language.toLowerCase() === language;
      });
      return filterBillboard;
    },
    refreshFilter() {
      localStorage.removeItem(SELECT_NEW_GROUP)
      localStorage.removeItem(SELECT_NEW_CUSTOM_CATEGORY)
      localStorage.removeItem(ALL_GROUPS_CATEGORIES_SELECT)
      localStorage.removeItem(SEARCH_NAME)
      this.initializeSelection();
      this.updateSelectedGroupGlobal([]);
      this.updateSelectedCategoryGlobal([]);
      this.updateSelectedSearchGlobal([]);
      this.cleanPrice();
      this.cleanBrand();
      this.showMore = true;
      this.sortByFilter = '1';
    },
    adjustPriceSort() {
      this.list = this.savedList;

      const tempPrice = [];
      if (this.priceFilter && this.priceFilter < 51) {
        let sortedData = this.list.filter(item => item.Price <= this.priceFilter).map((a) => {
          tempPrice.push(a);
        });
        this.list = tempPrice;
      }

      const tempBrand = [];
      if (this.brandFilter && this.brandFilter.length > 0) {
        this.list.map(item => {
          this.brandFilter.map(brand => {
            if (item.Brand === brand) {
              tempBrand.push(item);
            }
          });
        });
        this.list = tempBrand;
      }

      if ((!this.brandFilter || this.brandFilter.length < 1) && (!this.priceFilter || this.priceFilter > 50)) {
        this.list = this.savedList;
      }

      let tempOut = [];
      let tempReg = [];
      let listOut = [];
      let listReg = [];
      if (this.list) {
        let sortOut = this.list.map((a) => {
          if (this.isOutOfStock(a)) {
            tempOut.push(a);
          } else {
            tempReg.push(a);
          }
        });
      }
      if (this.sortByFilter === '1') {
        // if (this.selectedCustomCategoryLocal[0]) {
        //   // '热门选项下的default的排序需要和首页一样，类别的default和原来一样'
        //   return this.list = this.reqProductsWithCustomCategoryData.reverse()
        // }
        listOut = tempOut.sort((a, b) => {
          return Number(a.GeneralNum) < Number(b.GeneralNum) ? 1 : -1;
        });
        listReg = tempReg.sort((a, b) => {
          return Number(a.GeneralNum) < Number(b.GeneralNum) ? 1 : -1;
        });
        // this.list = listReg.concat(listOut);
        this.list = listReg.concat(listOut).sort(function (itemA, itemB) {
          const refNumA = itemA.RefNum
          const refNumB = itemB.RefNum
          return refNumA.localeCompare(refNumB)
        })
      }
      if (this.sortByFilter === '2') {
        listOut = tempOut.sort((a, b) => {
          return Number(a.Name[0]) > Number(b.Name[0]) ? 1 : -1;
        });
        listReg = tempReg.sort((a, b) => {
          return Number(a.Name[0]) > Number(b.Name[0]) ? 1 : -1;
        });
        this.list = listReg.concat(listOut);
      }
      if (this.sortByFilter === '3') {
        listOut = tempOut.sort((a, b) => {
          return Number(a.Price) > Number(b.Price) ? 1 : -1;
        });
        listReg = tempReg.sort((a, b) => {
          return Number(a.Price) > Number(b.Price) ? 1 : -1;
        });
        this.list = listReg.concat(listOut);
      }
      //保留之前的所有的产品
      this.list2=JSON.parse(JSON.stringify(this.list));
      
      //默认显示有库存的产品 (this only for login)
      if (this.loggedIn === true) {
        this.stockLevelChecked=true;
        this.isSockLevelList(this.list);
      }
    },
    cleanPrice() {
      this.priceFilter = 51;
      this.priceOpen = true;
      this.adjustPriceSort();
    },
    cleanBrand() {
      this.brandFilter = [];
      this.brandOpen = true;
      if (this.searchBrand) {
        this.brandFilter = [this.searchBrand];
        this.brandOpen = true;
        this.searchBrand = '';
      }
      this.adjustPriceSort();
    },
    toggleCustomCategories() {
      this.customCategoriesOpen = !this.customCategoriesOpen;
    },
    toggleGroups() {
      this.groupsOpen = !this.groupsOpen
    },
    togglePrice() {
      this.priceOpen = !this.priceOpen;
    },
    toggleBrand() {
      this.brandOpen = !this.brandOpen;
    },
    async selectNewGroup(item,text) {
      //保存id
      this.changeNavGoId(item);
      
      if(!text){
        //保存显示产品的类型
        this.changeShowProductsType1(null);
        this.changeShowProductsType2(null);
        this.changeShowProductsType3('group');
      }
      //类型数据中有数组
      if(Array.isArray(item)){
        let nameArray=[];
        let categoriesArray=[];
        item.forEach(item2 => {
          nameArray.push(item2.Name);
          categoriesArray.push(item2.Categories);
        })
        localStorage.setItem(SELECT_NEW_GROUP, JSON.stringify(item));
        localStorage.removeItem(SELECT_NEW_CUSTOM_CATEGORY);
        localStorage.removeItem(SEARCH_NAME);
        this.updateSelectedGroupGlobal(nameArray);
        this.allGroups_Categories_id = null
        this.allGroups_Categories = categoriesArray;
        this.allGroups_Categories_ids = [];
        this.setLocalAllGroupsCategoriesIds();
        this.changeSelectAfter()
        let index=-1;
        nameArray.forEach(name => {
          this.allGroups.forEach((group,i) => {
            if(name === group.Name){
              index = i;
            }
          })
        })
        index > -1 && this.scrollToDom('allGroups'+index)
      }else{
        localStorage.setItem(SELECT_NEW_GROUP, JSON.stringify(item));
        localStorage.removeItem(SELECT_NEW_CUSTOM_CATEGORY);
        localStorage.removeItem(SEARCH_NAME);
        this.updateSelectedGroupGlobal([item.Name]);
        this.allGroups_Categories_id = null
        this.allGroups_Categories = item.Categories;
        this.allGroups_Categories_ids = [];
        this.setLocalAllGroupsCategoriesIds();
        this.changeSelectAfter()
        const index = this.allGroups.findIndex(it => it.Name === item.Name)
        index > -1 && this.scrollToDom('allGroups'+index)
      }
      return true
    },
    navGroup(item) {
      if(Array.isArray(item)){
        let flag=false;
        let idArray=[];
        item.forEach(data => {
          if(data.Name == 'Beauty & Health & Home'){
            this.activeGroupEn = 'Beauty & Health & Home';
            this.activeGroupCh = 'Beauty & Health & Home';
            flag=true;
          }
          idArray.push(data.ProductGroup_id);
        })
        if(!flag){
          this.activeGroupEn = 'ALL Groceries';
          this.activeGroupCh = 'ALL Groceries';
        }
        this.activeCategoryEn = '';
        this.activeCategoryCh = '';
        this.fetchSelectedGroup(idArray);
        // this.fetchBrandOptions('group', idArray);
      }else{
        this.activeGroupEn = item.Name;
        this.activeGroupCh = item.Description;
        this.activeCategoryEn = '';
        this.activeCategoryCh = '';
        this.fetchSelectedGroup(item.ProductGroup_id);
        // this.fetchBrandOptions('group', item.ProductGroup_id);
      }
    },
    selectNewCustomCategory(item, index, isAdd) {
      const itemName = item.Name
      localStorage.setItem(SELECT_NEW_CUSTOM_CATEGORY, JSON.stringify(item));
      localStorage.removeItem(SELECT_NEW_GROUP);
      localStorage.removeItem(ALL_GROUPS_CATEGORIES_SELECT)
      localStorage.removeItem(SEARCH_NAME)
      const arr = []
      const selectedCustomCategoryGlobal = JSON.parse(JSON.stringify(this.selectedCustomCategoryGlobal))
      if (isAdd) {
        arr.push(...selectedCustomCategoryGlobal)
        const arrIdx = arr.indexOf(itemName)
        if (arrIdx < 0) {
          arr.push(itemName)
        } else {
          arr.splice(arrIdx, 1)
        }
      } else {
        arr.push(itemName)
      }
      this.updateSelectedCustomCategoryGlobal(arr);
      this.changeSelectAfter()
      if (!isAdd) {
        const idx = this.customCategories.findIndex(it => it.Name === itemName)
        idx > -1 && this.scrollToDom(`hot-`+idx)
      }
    },
    navCustomCategory(item, itemList, isMultiple) {
      if (isMultiple) {
        item = itemList[0]
      }
      this.activeGroupEn = item.Name;
      if (item.IsButton) {
        this.activeGroupCh = item.Name;
      } else {
        this.activeGroupCh = item.Description;
      }
      this.activeCategoryEn = '';
      this.activeCategoryCh = '';

      let ids = item.ProductCategory2_id
      if (isMultiple) {
        ids = itemList.map(item => item.ProductCategory2_id).join(',')
      }
      this.fetchSelectedCustomCategory(ids);
      this.fetchBrandOptions('category2', ids);
    },
    selectNewCategory(item) {
      this.curSelectNewCategoryItem = item
      this.updateSelectedCategoryGlobal([item.Name]);
      this.changeSelectAfter()
    },
    navCategory(item, parent) {
      this.activeGroupEn = parent.Name;
      this.activeGroupCh = parent.Description;
      this.activeCategoryEn = item.Name;
      this.activeCategoryCh = item.Description;

      this.selectedGroupLocal = [parent.Name];
      this.allGroups_Categories = parent.Categories;
      this.allGroups_Categories_ids = [item.ProductCategory_id];
      this.setLocalAllGroupsCategoriesIds();

      this.fetchSelectedCategories([item.ProductCategory_id]);
      this.fetchBrandOptions('category', item.ProductCategory_id);
    },
    selectNewSearch(item, type) {
      this.searchType = type;
      if (type === 'Brand') {
        this.searchBrand = item;
      } else {
        this.searchBrand = '';
        localStorage.setItem(SEARCH_NAME, item)
      }
      if (item) {
        this.updateSelectedSearchGlobal([item]);
      } else {
        this.initializeSelection();
      }
      this.changeSelectAfter()
    },
    navSearch(item) {
      this.activeGroupEn = item;
      this.activeGroupCh = item;
      this.activeCategoryEn = '';
      this.activeCategoryCh = '';
      this.fetchProductWithSearchTerm(item);
      // this.fetchBrandOptions('search', item);
    },

    formatToolTip(val) {
      if (this.priceFilter !== 51) {
        this.priceFilterDisplay = '< $' + this.priceFilter;
        return '$' + val;
      } else {
        this.priceFilterDisplay = '';
        return 'All';
      }
    },
    fetchBrandOptions(type, id) {
      this.brandFilterOptions = [];
      this.fetchBrands({type, id})
        .then(res => {
          this.brandFilterOptions = res.data;
        }).catch(err => {
        console.log('err brand', err);
      })
    },
    async fetchProductWithSearchTerm(product) {
      this.showMore = true;
      this.savedList = [];
      this.list = [];
      this.isLoading = true;
      let url = ``;
      if (this.searchType === 'Brand') {
        url = '?Brand=' + encodeURIComponent(product);
      } else {
        url = '?Name=' + encodeURIComponent(product);
      }
      //设置仓库id
      let data={
        company_id: 0,
        warehouse_id: 0
      };
      if(this.companyId === 1){
        data.company_id = 1
        data.warehouse_id = 1
      }
      if(this.companyId === 2){
        data.company_id = 2
        data.warehouse_id = 2
      }
      if(this.companyId === 3){
        data.company_id = 3
        data.warehouse_id = 8
      }
      if(this.companyId === 4){
        data.company_id = 4
        data.warehouse_id = 9
      }
      if(this.companyId === 5){
        data.company_id = 5
        data.warehouse_id = 10
      }
      await this.fetchProducts({name:url,company_id:data.company_id,warehouse_id:data.warehouse_id})
        .then(res => {
          this.brandFilterOptions = res.data.Brands;
          this.isLoading = false;
          const temp1 = [];
          const temp2 = [];
          let sortedData = [];
          sortedData = res.data.Products.map((a) => {
            a['ThumbnailLarge'] = a.Thumbnail;
            if (this.isOutOfStock(a)) {
              temp2.push(a)
            } else {
              temp1.push(a)
            }
          });
          this.listOut = temp2.sort((a, b) => {
            return Number(a.GeneralNum) > Number(b.GeneralNum) ? 1 : -1;
          });
          this.listReg = temp1.sort((a, b) => {
            return Number(a.GeneralNum) > Number(b.GeneralNum) ? 1 : -1;
          });
          this.savedList = this.listReg.concat(this.listOut);
          this.list = this.listReg.concat(this.listOut);
          this.adjustPriceSort();
        })
        .catch(err => {
          this.isLoading = false;
          console.log('err search', err);
        })
    },
    async fetchSelectedCategories(id) {
      this.showMore = true;
      this.list = [];
      this.isLoading = true;
      //设置仓库id
      let data={
        company_id: 0,
        warehouse_id: 0
      };
      if(this.companyId === 1){
        data.company_id = 1
        data.warehouse_id = 1
      }
      if(this.companyId === 2){
        data.company_id = 2
        data.warehouse_id = 2
      }
      if(this.companyId === 3){
        data.company_id = 3
        data.warehouse_id = 8
      }
      if(this.companyId === 4){
        data.company_id = 4
        data.warehouse_id = 9
      }
      if(this.companyId === 5){
        data.company_id = 5
        data.warehouse_id = 10
      }
      await this.fetchCategories({id,company_id:data.company_id,warehouse_id:data.warehouse_id})
        .then(res => {
          this.isLoading = false;
          const ctemp1 = [];
          const ctemp2 = [];
          let sortedData = [];
          // if (this.priceFilter) {
          //   sortedData = res.data.filter(item => item.Price <= this.priceFilter).map((a)=>{
          //     if(this.isOutOfStock(a)) {
          //       ctemp2.push(a)
          //     }else {
          //       ctemp1.push(a)
          //     }
          //   });
          // } else {
          sortedData = res.data.map((a) => {
            if (this.isOutOfStock(a)) {
              ctemp2.push(a);
            } else {
              ctemp1.push(a);
            }
          });
          // }
          this.catOut = ctemp2.sort((a, b) => {
            return Number(a.GeneralNum) > Number(b.GeneralNum) ? 1 : -1;
          });
          this.catReg = ctemp1.sort((a, b) => {
            return Number(a.GeneralNum) > Number(b.GeneralNum) ? 1 : -1;
          });
          this.savedList = this.catReg.concat(this.catOut);
          this.list = this.catReg.concat(this.catOut);
          this.adjustPriceSort();
        })
        .catch(err => {
          this.isLoading = false;
          console.log('err fetching product', err);
        })
    },
    fetchSelectedCustomCategory(id) {
      this.showMore = true;
      this.savedList = [];
      this.list = [];
      this.isLoading = true;
      this.fetchProductsWithCustomCategoryId({id,company_id:this.companyId,warehouse_id:this.warehouseId})
        .then(res => {
          this.reqProductsWithCustomCategoryData = res.data
          this.isLoading = false;
          const temp1 = [];
          const temp2 = [];
          let sortedData = [];
          sortedData = res.data.map((a) => {
            a['ThumbnailLarge'] = a.Thumbnail;
            if (this.isOutOfStock(a)) {
              temp2.push(a);
            } else {
              temp1.push(a);
            }
          });
          // }
          this.listOut = temp2.sort((a, b) => {
            return Number(a.GeneralNum) > Number(b.GeneralNum) ? 1 : -1;
          });
          this.listReg = temp1.sort((a, b) => {
            return Number(a.GeneralNum) > Number(b.GeneralNum) ? 1 : -1;
          });
          this.savedList = this.listReg.concat(this.listOut);
          this.list = this.listReg.concat(this.listOut);
          this.adjustPriceSort();
        })
        .catch(err => {
          this.isLoading = false;
          console.log('err', err);
        });
    },
    fetchSelectedGroup(id) {
      // this.currentGroupId = id;
      this.showMore = true;
      this.savedList = [];
      this.list = [];
      this.isLoading = true;
      this.fetchProductsWithGroupAll().then(resOut => {
        if(Array.isArray(id)){
          let categoriesArray=[];
          let ids=[];
          id.forEach(data => {
            resOut.data.map(r => {
              if (r.ProductGroup_id === data) {
                categoriesArray.push(r.Categories);
                ids.push(data);
              }
            });
          })
          this.currentGroupCategories = categoriesArray;
          id=ids.join();
        }else{
          resOut.data.map(r => {
            if (r.ProductGroup_id === id) {
              this.currentGroupCategories = r.Categories;
            }
          });
        }
        this.fetchProductsWithGroupId({id,company_id:this.companyId,warehouse_id:this.warehouseId})
          .then(res => {
            this.isLoading = false;
            const temp1 = [];
            const temp2 = [];
            let sortedData = [];
            res.data.map((r, i) => {
              this.currentGroupCategories.map((r2, j) => {
                if (r.ProductCategory1_id === r2.ProductCategory_id) {
                  res.data[i].GeneralNum = (99 - j).toString() + res.data[i].GeneralNum;
                }
              })
            })
            sortedData = res.data.map((a) => {
              if (this.isOutOfStock(a)) {
                temp2.push(a);
              } else {
                temp1.push(a);
              }
            });
            // }
            this.listOut = temp2.sort((a, b) => {
              return Number(a.GeneralNum) > Number(b.GeneralNum) ? 1 : -1;
            });
            this.listReg = temp1.sort((a, b) => {
              return Number(a.GeneralNum) > Number(b.GeneralNum) ? 1 : -1;
            });
            this.savedList = this.listReg.concat(this.listOut);
            this.list = this.listReg.concat(this.listOut);
            this.adjustPriceSort();
          })
          .catch(err => {
            this.isLoading = false;
            console.log('err', err);
          });

      }).catch(err => {
        console.log('error', err);
      });
    },
    filterGroups(filter) {
      let list = this.list.slice();
      let sortedList = [];
      if (filter === 'sale') {
        sortedList = list.sort((a, b) => {
          return a.IsPromotion ? 1 : -1;
        })
      }
      if (filter === 'low') {
        sortedList = list.sort((a, b) => {
          return a.Price > b.Price ? 1 : -1;
        })
      }
      if (filter === 'high') {
        sortedList = list.sort((a, b) => {
          return a.Price < b.Price ? 1 : -1;
        })
      }
      this.list = sortedList
    },
    throttleAddToCart: _.debounce(function (item, e) {
      e.preventDefault();
      busUtil.$emit('addToCartDrop', e, item)
      this.addThisToCart(item)
    }, 150, {'leading': true, 'trailing': true}),
    addThisToCart: function (item) {
      if (!localStorage.getItem('warehouseLocationWeb') && localStorage.getItem('shippingMethodGlobal') === 'Pickup') {
        this.toggleWarehouseSelectionModalVisibility(true);
        return;
      }
      if (!localStorage.getItem('warehouseLocationWeb') && localStorage.getItem('shippingMethodGlobal') === 'Delivery') {
        this.toggleZipcodeModalVisibility(true);
        return;
      }
      if (!this.addToCartLoading) {
        if (isUserAuthenticated()) {
          this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item})
        } else {
          this.$store.dispatch('cart/incrementLocalCart', [item])
        }
      }
    },
    handleAddToCartSuccess(payload) {
      this.$store.dispatch('cart/addCart', payload.item)
        .then(() => {
          if (isUserAuthenticated()) {
            this.$store.dispatch('cart/getCart');
          }
        });
    },
    handleAddToCartFail(product) {
      if (localStorage.Lang === 'ch') {
        alert( this.$t('stock_msg_1') + `${product.Name}` +  this.$t('stock_msg_2'));
      } else {
        alert(`Sorry, there are only ${product.InventoryQuantity} available of ${product.Name}`);
      }
    },
    goToHome() {
      this.$router.push(`/home`);
    },
    clickShowMore() {
      this.pageInfo.pageNum++
    },
    showMoreRecommend() {
      this.isLoading = true;
      this.fetchProductsWithCustomCategoryId({id:'',company_id:this.companyId,warehouse_id:this.warehouseId})
        .then(res => {
          this.isLoading = false;
          const resData = res.data;
          if (!resData) {
            return
          }
          const length = resData.length
          if (!length) {
            return;
          }
          const {Name, Description, ProductCategory2_id} = resData[length - 1]
          this.selectedCustomCategoryLocal = [Name];
          this.navCustomCategory({
            Name: Name,
            Description: Description,
            ProductCategory2_id: ProductCategory2_id
          });
        })
        .catch(err => {
          this.isLoading = false;
          console.log('err', err);
        });
      this.changeDocumentScrollTop()
    },
    switchView(view) {
      this.currentView = view;
    },
    getStarIndex(rating) {
      let temp = [];
      if (rating || rating === 0) {
        for (let i = 1; i < 6; i++) {
          if (rating >= i) {
            temp.push(star2);
          } else if (rating > (i - 1) && rating < i) {
            temp.push(star1);
          } else if (rating <= (i - 1)) {
            temp.push(star0);
          }
        }
      } else {
        temp = [star0, star0, star0, star0, star0];
      }
      return temp;
    },
    checkViewableLanguages(data, lang) {
      for (let i = 0; i < data.split(',').length; i++) {
        if (data.split(',')[i] === lang) {
          return true;
        }
      }
      return false;
    },
    onClickBillboard(url, type) {
      if (type === "URL") {
        window.location.href = url;
      } else if (type === "Category2") {
        this.selectNewCustomCategory({Name: url});
        this.changeDocumentScrollTop()
      } else if (type === "Group") {
        this.selectNewGroup({Name: url});
        this.changeDocumentScrollTop()
      } else if (type === "Category") {
        this.selectNewCategory({Name: url});
        this.changeDocumentScrollTop()
      } else {

      }
    },

    // ----- -- -- -- - ------ -- -----
    searchProduct() {
      //保存显示产品的类型
      this.changeShowProductsType1(null);
      this.changeShowProductsType2('search');
      this.changeShowProductsType3(null);
      if (this.$router.currentRoute.path !== '/collections') {
        this.$router.push(`/collections`);
        setTimeout(() => {
          this.$root.selectNewSearch(this.searchTerm, 'Name');
        }, 600);
      } else {
        this.$root.selectNewSearch(this.searchTerm, 'Name');
      }
    },
    // 滚动到指定DOM
    scrollToDom(ref) {
      this.$nextTick(() => {
        const refC = this.$refs[ref]
        if (!refC) {
          return console.log(refC)
        }
        const comC = refC[0]
        comC && comC.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center'
        })
      })
    },
    // 格式化显示
    formatCustomCategoriesCheckbox(item) {
      const {Name, Description, ViewableLanguages, IsButton} = item
      if (this.curIsEnglish && this.checkViewableLanguages(ViewableLanguages, 'EN')) {
        return Name
      }
      if (this.curIsChinese && this.checkViewableLanguages(ViewableLanguages, 'ZH')) {
        return !IsButton ? Description : Name
      }
      return ''
    },
    // 滚动页面的滚动条
    changeDocumentScrollTop() {
      //距离网页顶部的距离
      document.documentElement.scrollTop = 700
    },
    changeSelectAfter() {
      this.changeDocumentScrollTop();
      this.cleanPrice();
      this.cleanBrand();
    },
    setLocalAllGroupsCategoriesIds() {
      localStorage.setItem(ALL_GROUPS_CATEGORIES_SELECT, JSON.stringify(this.allGroups_Categories_ids));
    },
    bannerSwiperMouseenter() {
      const bannerSwiperCom = this.$refs.bannerSwiperRef
      if (!bannerSwiperCom) {
        return
      }
      bannerSwiperCom.swiper.autoplay.stop()
    },
    bannerSwiperMouseleave() {
      const bannerSwiperCom = this.$refs.bannerSwiperRef
      if (!bannerSwiperCom) {
        return
      }
      bannerSwiperCom.swiper.autoplay.start()
    },
    handleQueryParams() {
      // type=1 为分类
      // type=2 为category2
      // type=3 为搜索

      const {name, type} = this.$route.query
      let key = ''
      switch (Number(type)) {
        case 1: key = SELECT_NEW_GROUP
          break;
        case 2: key = SELECT_NEW_CUSTOM_CATEGORY
          break;
        case 3: key = SEARCH_NAME
          break;
        default: key = SELECT_NEW_GROUP
      }
      if (name) {
        localStorage.removeItem(SELECT_NEW_GROUP);
        localStorage.removeItem(SELECT_NEW_CUSTOM_CATEGORY);
        localStorage.removeItem(SEARCH_NAME);
        const str = decodeURIComponent(name);
        let val = JSON.stringify({Name: str});
        if (Number(type) === 3) {// 搜索特殊处理
          val = str;
        }
        localStorage.setItem(key, val);
        if (!this.isApp) {
          setTimeout(() => {
            const {fullPath, query} = this.$route;
            const params = JSON.stringify({fullPath, query});
            const UniversalLink = this.isIosWeb ? this.openAppInfo.UniversalLink : this.openAppInfo.urlSchemes;
            window.location = `${UniversalLink}?type=email_click_product&params=${encodeURIComponent(params)}`;
          }, 3000)
        }

      }
    },
    setIsFixedByScrollNumber(event) {
      const val = event.target.scrollTop > 250
      if (this.isFixed === val) return
      this.isFixed = val
    },
    initElScrollHandle() {
      this.isFixed = false
      const el = document.getElementById('product-list-container-id')
      el.addEventListener('scroll', this.setIsFixedByScrollNumber)
    },
    removeElScrollHandle() {
      const el = document.getElementById('product-list-container-id')
      el && el.removeEventListener('scroll', this.setIsFixedByScrollNumber)
    },
    getSelectItemName(selectItem, newVal0LowerCaseStr) {
      let selectItemName = undefined;
      if (selectItem && typeof selectItem.Name === "string") {
        selectItemName = selectItem.Name.toLowerCase();
      }
      if (selectItemName && selectItemName === newVal0LowerCaseStr) {
        // 名字对不上，清除
        this.curSelectNewCategoryItem = null;
        return selectItemName
      }
      return undefined
    },
    // 显示所有的商品
    showAllProduct() {
      // 默认不分页的话，不再出现分页
      if (!defaultIsPage) return
      this.isPage = false;
    },
    // 显示分页后需要显示的商品
    showPageProduct() {
      // 默认不分页的话，不再出现分页
      if (!defaultIsPage) return
      this.isPage = true;
    },
    imgLoad() {
    },
    imgAbort() {
    },
    //是否显示有库存的方法
    isSockLevel(){
      this.isLoading = true;
      //显示有库存的产品
      if(this.stockLevelChecked){
        //显示有库存的产品
        this.isSockLevelList(this.list);
      }else{
        //显示所有的产品
        this.list=JSON.parse(JSON.stringify(this.list2));
      }
      //加载中
      setTimeout(()=>{
        this.isLoading = false;
      },1000)
    },
    //是否显示价格的方法
    isPrice(){
      //修改显示价格
      this.changeShowPrice(this.priceChecked);
    },
    //默认显示有库存的产品
    isSockLevelList(list){
      const isSockLevelArr=[];
      list.forEach(item => {
        //有库存的产品
        if(item.InventoryQuantity>0){
          isSockLevelArr.push(item);
        }
      })
      
      this.list=JSON.parse(JSON.stringify(isSockLevelArr));
    },
    getProductCardImgIsLoad() {
      if (!this.$refs.productCardRef) return true
      return !this.$refs.productCardRef.find(item => !item.imgIsLoad)
    },
    getProductListIsLoading() {
      return this.isLoading
    },
    //点击商品图片
    clickZoom(images){
      if(images){
        //显示商品图片的弹窗
        this.imagesVisible=true;
        this.images=images;
      }
    },
    closeImages(){
      this.imagesVisible=false;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (isUserAuthenticated() && to.name === 'purchase') {
      this.$store.dispatch('cart/getCart')
        .then(() => {
          const cartItems = {};
          cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
          cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
          cartItems.ShippingMethod = "Delivery";
          cartItems.Tip = 0;
          cartItems.TipPercentage = 0;
          cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
          this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
            .then(() => {
              this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
            })
        })
    }
    this.clearPromoCode();
    this.clearCard();
    next();
  },
  computed: {
    ...mapState({
      allGroups: state => state.navbar.allGroups,
      activeProduct: state => state.products.activeProduct,
      product: state => state.products.productDetails[0],
      necessaryCartItems: state => state.cart.necessaryCartItems,
      itemCount: state => state.cart.itemCount,
      billboards: state => state.billboard.billboardImages,
      selectedGroupGlobal: state => state.products.selectedGroupGlobal,
      selectedCustomCategoryGlobal: state => state.products.selectedCustomCategoryGlobal,
      selectedCategoryGlobal: state => state.products.selectedCategoryGlobal,
      selectedSearchGlobal: state => state.products.selectedSearchGlobal,
      customCategories: state => state.products.customCategories,
      currentLang: state => state.navbar.currentLang,
      openAppInfo: state => state.openAppInfo,
      isAndroidWeb: state => state.isAndroidWeb,
      isIosWeb: state => state.isIosWeb,
      companyId: state => state.products.companyId,
      warehouseId: state => state.products.warehouseId,
      loggedIn: state => state.auth.loggedIn,
    }),
    showList({curShowListNum, isPage}) {
      // return this.list.sort(this.outOfStockToEnd)
      if (!isPage) {
        this.changeShowList(this,list);
        return this.list
      }
      this.changeShowList(this.list.slice(0, curShowListNum));
      return this.list.slice(0, curShowListNum)
    },
    // 当前展示的商品的样式是否是默认样式
    currentViewIsGallery() {
      return this.currentView === GALLERY
    },
    customButtonCategories() {
      return this.customCategories.filter(item => item.IsButton)
    },
    customENButtonCategories() {
      return this.customButtonCategories.filter(item => this.checkViewableLanguages(item.ViewableLanguages, 'EN'))
    },
    customZHButtonCategories() {
      return this.customButtonCategories.filter(item => this.checkViewableLanguages(item.ViewableLanguages, 'ZH'))
    },
    isShowHotLists() {
      return this.selectedCustomCategoryLocal[0]
    },
    isShowCategoryButtons() {
      return this.selectedGroupLocal[0]
    },
    isShowCategorySubclassButtons() {
      return this.selectedGroupLocal.length > 0
    },
    collectionsFixedHeight() {
      const {isShowHotLists, isShowCategoryButtons, isShowCategorySubclassButtons} = this
      if (isShowHotLists) return 208
      if (isShowCategoryButtons) {
        if (isShowCategorySubclassButtons) return 308
        return 260
      }
      return 168
    },
    isShowShowMoreContent({isLoading, pageInfo, curShowListNum, isPage}) {
      if (!isPage) return false
      const total = pageInfo.total
      return !isLoading && total && curShowListNum < total
    },
    curShowListNum({pageInfo}) {
      return pageInfo.pageNum * pageInfo.pageSize || pageInfo.pageSize
    }
  },
  watch: {
    currentLang: function (newVal) {
      const selectedCustomCategoryGlobal = JSON.parse(JSON.stringify(this.selectedCustomCategoryGlobal));
      const newValIsCh = newVal === 'ch'
      let listName = 'customZHButtonCategories'
      if (newValIsCh) {
        listName = 'customENButtonCategories'
      }
      const list = this[listName]
      if (!list || !Array.isArray(list) || !list.length) {
        return
      }
      list.forEach(buttonItem => {
        const idx = selectedCustomCategoryGlobal.findIndex(item => item.toLowerCase().replaceAll(' ') === buttonItem.Name.toLowerCase().replaceAll(' '))
        idx > -1 && selectedCustomCategoryGlobal.splice(idx, 1, buttonItem.Description)
      })
      this.updateSelectedCustomCategoryGlobal(selectedCustomCategoryGlobal);
    },
    selectedGroupGlobal: function (newVal, oldVal) {
      this.selectedGroupLocal = newVal;
      if (newVal !== oldVal && newVal.length === 1) {
        const currentGroup = this.allGroups.filter(group => {
          return newVal[0].toLowerCase() === group.Name.toLowerCase();
        });
        this.navGroup(currentGroup[0]);
      }
      //如果数据是数组
      if (newVal !== oldVal && newVal.length > 1) {
        let currentGroup=[];
        newVal.forEach(name => {
          this.allGroups.forEach((group,i) => {
            if(name.toLowerCase() === group.Name.toLowerCase()){
              currentGroup.push(group);
            }
          })
        })
        this.navGroup(currentGroup);
      }
    },
    selectedCustomCategoryGlobal: function (newVal, oldVal) {
      this.selectedCustomCategoryLocal = newVal;
      const length = newVal.length
      const customCategories = this.customCategories
      if (newVal !== oldVal && length > 0 && customCategories.length) {
        const currentCustomCategory = customCategories.filter(customCategory => {
          const customCategoryName = customCategory.Name.toLowerCase();
          return newVal.find(name => name.toLowerCase() === customCategoryName)
        });
        if (length === 1) {
          return this.navCustomCategory(currentCustomCategory[0]);
        }
        // 选择了多个
        this.navCustomCategory({}, currentCustomCategory, true)
      }
    },
    selectedCategoryGlobal: function (newVal, oldVal) {
      let currentCategory = {};
      let parentGroup = {};
      if (newVal !== oldVal && newVal.length === 1) {
        const selectItem = this.curSelectNewCategoryItem
        const newVal0LowerCaseStr = newVal[0].toLowerCase()
        let selectProductCategory_id = ''
        const selectItemName = this.getSelectItemName(selectItem, newVal0LowerCaseStr)
        if (selectItemName && selectItem.ProductCategory_id) {
          selectProductCategory_id = selectItem.ProductCategory_id
        }

        this.allGroups.map(group => {
          group.Categories.find(cat => {
            // 有id判断下id，没有就只根据名字判断
            if (selectProductCategory_id && selectProductCategory_id !== cat.ProductCategory_id) {
              return false
            }
            if (newVal0LowerCaseStr === cat.Name.toLowerCase()) {
              parentGroup = group;
              currentCategory = cat;
              return true
            }
            return false
          });
        });
        this.navCategory(currentCategory, parentGroup);
      }
    },
    selectedSearchGlobal: function (newVal, oldVal) {
      if (newVal !== oldVal && newVal.length === 1) {
        this.navSearch(newVal[0]);
      }
    },
    filter: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.filterGroups(newVal);
      }
    },
    selectedCustomCategoryLocal(newVal) {
      clearTimeout(window.afm_selectedCustomCategoryLocalTimeoutId);
      window.afm_selectedCustomCategoryLocalTimeoutId = setTimeout(() => {
        const resCustomCategories = this.customCategories.filter(item => newVal.includes(item.Name))
        if (!resCustomCategories.length) {
          return
        }
        const curIsChinese = this.curIsChinese
        let activeGroupEnList = []
        let activeGroupChList = []
        resCustomCategories.forEach(item => {
          const {Name, Description, IsButton} = item;
          if (IsButton && curIsChinese) {
            activeGroupEnList.push(Description);
            activeGroupChList.push(Name)
            return
          }
          activeGroupEnList.push(Name);
          activeGroupChList.push(Description)
        })
        this.activeGroupEn = activeGroupEnList.join(',');
        this.activeGroupCh = activeGroupChList.join('，');
      }, 500)
    },
    list: {
      immediate: true,
      handler(newVal, oldVal) {
        let total = 0
        if (Array.isArray(newVal)) {
          total = newVal.length
        }
        if (this.pageInfo.total === total) return
        this.pageInfo.total = total
      },
      deep: true,
    },
    isLoading: {
      immediate: true,
      handler(newVal) {
        if (!newVal) return
        this.showPageProduct()
        if (this.pageInfo.pageNum === 1) return
        this.pageInfo.pageNum = 1
      }
    }
  },
  mounted() {
    this.$store.dispatch('billboard/fetchBillboardImages');
    this.$store.dispatch('products/fetchCustomCategories',{company_id: 1,warehouse_id: 1});
    this.$store.dispatch('navbar/fetchGroups');
    // this.$store.dispatch('products/fetchProductsWithGroupId', '');
    // this.$root.fetchSelectedGroup = this.fetchSelectedGroup.bind(this);
    this.$root.selectNewGroup = this.selectNewGroup.bind(this);
    this.$root.selectNewCategory = this.selectNewCategory.bind(this);
    this.$root.selectNewCustomCategory = this.selectNewCustomCategory.bind(this);
    this.$root.selectNewSearch = this.selectNewSearch.bind(this);
    this.$root.showMoreRecommend = this.showMoreRecommend.bind(this);
    this.$root.showAllProduct = this.showAllProduct.bind(this);
    this.$root.showPageProduct = this.showPageProduct.bind(this);
    this.$root.getProductCardImgIsLoad = this.getProductCardImgIsLoad.bind(this);
    this.$root.getProductListIsLoading = this.getProductListIsLoading.bind(this);
    this.cleanPrice();
    this.cleanBrand();
    let that = this
    Utils.$on("clearList", async function () {
      that.isLoading = true
      that.list = []
    });
  },
  activated() {
    this.initElScrollHandle()
    this.allGroups_Categories = [];
    this.selectedGroupLocal = []
    setTimeout(() => {
      this.handleQueryParams()
      if (this.selectedGroupGlobal.length < 1 && this.selectedCustomCategoryGlobal.length < 1 && this.selectedCategoryGlobal.length < 1 && this.selectedSearchGlobal.length < 1) {
        this.initializeSelection(true, true);
      }
    },2000)
  },
  deactivated() {
    this.removeElScrollHandle()
  }
}
</script>

<style lang="less">
@import "../assets/css/home.less";
@import "../assets/css/productListUse.less";
@import "../assets/css/public.less";

.rotate-enter-active .rotate-leave-active {
  transform: rotate(0.5turn);
}

.rotate {
  transform: rotateZ(180deg);
  transition: all 0.5s ease-out;
}

.rotate-back {
  transform: rotateZ(0);
  transition: all 0.5s ease-out;
}

.MbproductList {
  .category-buttons {
    display: block !important;
    padding-top: 0;
    margin-bottom: 0;

    ul {
      flex-direction: unset;
      width: unset;
      justify-content: unset;
      align-items: unset;
      flex-wrap: unset;
      margin: unset;

      li {
        margin-right: 15px;
        flex-shrink: 0;
        text-align: center;
        font-size: 12px;
        width: 56px;
        padding-bottom: unset;

        .group-button-container {
          display: unset;
          flex-direction: unset;
          justify-content: unset;
          align-items: unset;
          margin-bottom: unset;

          .image-placeholder {
            background-color: unset;
            cursor: unset;

            box-shadow: 1px 3px 4px 2px rgba(0, 0, 0, 0.05);
            border-radius: 4px;
            overflow: hidden;
            width: 100%;
            height: 56px;
            display: flex;
            margin-bottom: 7px;
            border: 1px solid transparent;
            justify-content: center;
            align-items: center;

            .button-image {
              max-width: 90%;
              max-height: 90%;
            }
          }

          .image-placeholder.is-active {
            background: unset;
          }

          .group-button-name {
            font-size: unset;
            font-family: unset;
            font-weight: unset;
            color: inherit;
            padding-top: unset;
          }
        }
      }
    }
  }
  .hidden {
    display: none !important;
  }
  .category-subclass-buttons {
    background-color: #FFFFFF;
    transition: all 0.3s;
    z-index: 998;
  }
  .fixed_container {
    background-color: #131e1e;
    color: #FFFFFF;
    width: 100vw;
    //margin-left: -16px;
    transform: translateX(-16px);
    padding: 5px 0;
    position: fixed;
    top: 50px;

    .allGroups_Categories {
      li {
        &.active{
          color: #ffffff;
          border-radius: 0px;
          background-color: transparent;
          border-bottom: 3px solid #7cc26a;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/productList.vue